import React from "react"
import NewsFeatured from "./NewsFeatured"
import { Link } from "gatsby"
import { useStaticQuery, graphql } from "gatsby"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import { BsCalendar3 } from "react-icons/bs"
import { AiFillTag } from "react-icons/ai"
import SearchBar2 from "../Layout/SearchBar2"
import daliaTalk from "../../assets/images/daliaTalk.jpg"

import { motion } from "framer-motion"
import TextMarqueeBannerNM from "../../utils/TextMarqueeBannerNM"
import NewsAccordion from "./NewsAccordion"
import NewsFeaturedText from "./NewsFeaturedText"

const NewsHero2 = () => {
  const { allStrapiArticle, strapiPageNewsMedia, allStrapiCategory, strapiPageHome } =
    useStaticQuery(graphql`
      {
        allStrapiArticle(
          filter: { isFeatureInterest: { eq: true } }
          limit: 4
        ) {
          nodes {
            id
            slug
            title
            description
            subtitle
            date
            cover {
              alternativeText
              localFile {
                childImageSharp {
                  gatsbyImageData(layout: CONSTRAINED)
                }
              }
            }
          }
        }
        allStrapiCategory(
          filter: {
            articles: { elemMatch: { isFeatureInterest: { eq: true } } }
          }
        ) {
          nodes {
            slug
            name
          }
        }
        strapiPageNewsMedia {
          heroTitle
          heroSubtitle
          heroPostsText
          heroFeaturedText
          heroButton
          heroImage {
            alternativeText
            localFile {
              childImageSharp {
                gatsbyImageData(layout: CONSTRAINED)
              }
            }
          }
        }
        strapiPageHome {
          spotifyLink
        }
      }
    `)
  const cardNews = allStrapiArticle.nodes
  const cardHeroTitles = strapiPageNewsMedia
  var options = {
    year: "numeric",
    month: "long",
    day: "numeric",
  }

  const gridAnimate = {
    offScreen: { opacity: 0, y: 50 },
    onScreen: {
      opacity: 1,
      y: 0,
      transition: { type: "spring", bounce: 0.4, duration: 2 },
    },
  }

  const opacity = {
    offScreen: { opacity: 0 },
    onScreen: {
      opacity: 1,
      transition: { type: "spring", bounce: 0.4, duration: 2 },
    },
  }

  return (
    <>
      <SearchBar2 />
      <div className={`news`}>
        <NewsFeatured cardHeroTitles={cardHeroTitles} />
        <TextMarqueeBannerNM
          podcastTag={"Escúchanos en nuestro podcast"}
          backgroundColor="#FF3FB7"
        />
        <div className="dalia-talk-container">
          <div className="left">
            <img src={daliaTalk} alt="podcast" />
          </div>
          <div className="middle">
            <iframe
              title="Dalia Talks Podcast"
              // style={{ borderRadius: "5px", marginTop: "20px" }}
              src={strapiPageHome.spotifyLink}
              width="100%"
              height="232px"
              frameBorder="0"
              allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
            ></iframe>
          </div>
          <div className="right">
            <h4>Dalia Talks</h4>
            <p>
              Un podcast con hacks sobre life skills o habilidades blandas,
              liderazgo, equidad de género y diversidad e inclusión,
              indispensable.
            </p>
          </div>
        </div>
        {/* <TextMarqueeBannerPost
          articleTag={"Escúchanos en nuestro podcast"}
          backgroundColor="#FF3FB7"
        /> */}
        <div className="container-orange">
          <h4 className="recommend-title">Recomendación de los editores</h4>
          <motion.div
            className="grid-recommend"
            variants={gridAnimate}
            initial={"offScreen"}
            whileInView={"onScreen"}
            transition={{ staggerChildren: 0.2 }}
          >
            <div className="testimonial_text">
              {cardNews?.map((blog, index) => {
                const pathToImage = getImage(blog.cover?.localFile)
                const publishDate = new Date(blog.date)?.toLocaleDateString(
                  "es-MX",
                  options
                )
                return (
                  <motion.div
                    variants={opacity}
                    initial={"offScreen"}
                    whileInView={"onScreen"}
                    transition={{ staggerChildren: 0.2 }}
                    key={index}
                    className="testimonial_card"
                  >
                    <Link to={`/blog/${blog.slug}`}>
                      <div className="testimonial_image">
                        <GatsbyImage
                          image={pathToImage}
                          alt={blog.cover.alternativeText}
                        />
                      </div>
                    </Link>
                    <div className="testimonial_card_position">
                      <Link to={`/blog/${blog.slug}`}>
                        <h3>{blog.title}</h3>
                      </Link>
                      <p>{blog.description}</p>
                      <div className="ref">
                        <Link to={`/blog/${blog.slug}`}>
                          <div className="button">Leer más</div>
                        </Link>
                      </div>
                      <div className="testiminail_text_footer">
                        <div className="testiminail_text_footer_center">
                          <AiFillTag className="testiminail_text_footer_icon" />
                          <p>{allStrapiCategory?.nodes[0]?.name}</p>
                        </div>
                        <div
                          className="testiminail_text_footer_center"
                          style={{ display: "flex", justifyContent: "end" }}
                        >
                          <BsCalendar3 className="testiminail_text_footer_icon" />
                          <p>{publishDate}</p>
                        </div>
                      </div>
                    </div>
                  </motion.div>
                )
              })}
            </div>
          </motion.div>
          <NewsAccordion />
          <NewsFeaturedText />
          <Link className="blog-button" to="/blog">
            <button>{cardHeroTitles.heroButton}</button>
          </Link>
        </div>
      </div>
    </>
  )
}

export default NewsHero2
